import { createFileRoute, redirect } from "@tanstack/react-router";
import { I18nProvider, locales, type Locale } from "@/i18n";
import Layout from "@/components/layout/Layout";

const isLocale = (value: string): value is Locale => (locales as string[]).includes(value);

export const Route = createFileRoute("/$lang")({
  beforeLoad: ({ params }) => {
    if (!isLocale(params.lang)) {
      throw redirect({ to: "/$lang", params: { lang: "en" }, replace: true });
    }
  },
  component: LocaleLayout,
});

function LocaleLayout() {
  const { lang } = Route.useParams();
  const locale: Locale = isLocale(lang) ? lang : "en";
  return (
    <I18nProvider locale={locale}>
      <Layout />
    </I18nProvider>
  );
}
